import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCustomerDetails } from "./contactAPI";

const initialState = null;

export const fetchCustomerData = createAsyncThunk(
    'ui/fetchCustomerData',
    async (obj, thunkAPI) => {
      const { getState } = thunkAPI;
      const response = await getCustomerDetails(obj);
      return response?.data;
    }
);

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
      resetCustomerDataReducer: () => initialState,
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchCustomerData.pending, (state) => {
            return {
              ...state,
              status: "loading",
              dataLoaded: false,
              dataFetchFailed: false,
              customerData: initialState
            }
          })
          .addCase(fetchCustomerData.fulfilled, (state, action) => {
            return {
              ...state,
              status: "idle",
              customerData: action.payload,
              dataFetchFailed: false,
              dataLoaded: true
            }
          })
          .addCase(fetchCustomerData.rejected, (state) => {
            return {
              ...state,
              dataFetchFailed: true,
              customerData: null,
              status: "idle",
              dataLoaded: true,
            }
          })
        },
});


export const getCustomerData = (state) => state.customer?.customerData;
export const isCustomerDataLoaded  = (state) => state.customer?.dataLoaded;
export const { resetCustomerDataReducer } = customerSlice.actions;
export default customerSlice.reducer;
